import React, {useRef, useEffect, useMemo} from 'react'
import PropTypes from 'prop-types'
import {ReactLenis} from 'lenis/react'
import {cancelFrame, frame} from 'framer-motion'
import {isServer} from '../utils/utils'
import {OverlayScrollLock} from './overlay-manager'

function LenisProvider({children}) {
    const lenisRef = useRef(null)

    const lenisOptions = useMemo(
        () => ({
            autoRaf: false,
            // do not handle modals scrolling
            prevent: (node) => {
                // Chakra 2
                if (node.classList.contains('.chakra-modal__content-container')) {
                    return true
                }
                // navigation menu
                if (node.closest('.chakra-modal__body')) {
                    return true
                }
                // Chakra 3
                if (node.closest('.chakra-dialog__body')) {
                    return true
                }
                // chakra 3 drawer
                if (node.closest('.chakra-drawer__content')) {
                    return true
                }
                return false
            }
        }),
        []
    )

    useEffect(() => {
        if (isServer) return null

        function update(data) {
            const time = data.timestamp
            lenisRef.current?.lenis?.raf(time)
        }

        frame.update(update, true)

        return () => cancelFrame(update)
    }, [])

    return (
        <ReactLenis root options={lenisOptions} ref={lenisRef}>
            <OverlayScrollLock />
            {children}
        </ReactLenis>
    )
}

LenisProvider.propTypes = {
    children: PropTypes.node
}

export default LenisProvider
